module.exports = __webpack_public_path__ + "static/img/s81.64971abe.png";